'use strict';

var Item = { render: function () {
        var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { class: _vm.$style.item }, [_c('div', { class: _vm.$style.meta }, [_c('div', { class: _vm.$style.avatar }, [_vm._t("avatar")], 2), _vm._v(" "), _c('div', { class: _vm.$style.content }, [_c('div', { class: _vm.$style.title }, [_vm._t("title")], 2), _vm._v(" "), _c('div', { class: _vm.$style.description }, [_vm._t("description"), _vm._v(" "), _vm._t("datetime")], 2)])])]);
    }, staticRenderFns: [], cssModules: { "item": "ListItem_item_2D5ru", "meta": "ListItem_meta_1ObTL", "content": "ListItem_content_3NhsY", "title": "ListItem_title_103li", "description": "ListItem_description_uFgt6" },
    computed: {
        $style: function $style() {
            return this.$options.cssModules;
        }
    }
};

var prefixCls = 'tbo-tabs-tabpane';
var TabPane = { render: function () {
        var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('ul', { directives: [{ name: "show", rawName: "v-show", value: _vm.show, expression: "show" }], class: _vm.prefixCls }, [_c('div', { class: _vm.$style.list }, [_vm._l(_vm.data, function (val, key) {
            return _vm.data.length > 0 ? _c('li', { key: key, class: _vm.$style.item, on: { "click": function ($event) {
                        _vm.onItemClick(val, _vm.data);
                    } } }, [_c('item', { class: val.read ? _vm.$style.read : '' }, [val.avatar ? _c('Avatar', { class: _vm.$style.avatar, attrs: { "slot": "avatar", "src": val.avatar }, slot: "avatar" }) : _vm._e(), _vm._v(" "), _c('div', { class: _vm.$style.title, attrs: { "slot": "title" }, slot: "title" }, [_vm._v(" " + _vm._s(val.title) + " "), _c('div', { class: _vm.$style.extra }, [_vm._v(_vm._s(val.extra))])]), _vm._v(" "), _c('div', { attrs: { "slot": "description" }, slot: "description" }, [_c('div', { class: _vm.$style.description }, [_vm._v(" " + _vm._s(val.description) + " ")]), _vm._v(" "), _c('div', { class: _vm.$style.datetime }, [_vm._v(" " + _vm._s(val.datetime) + " ")])])], 1)], 1) : _vm._e();
        }), _vm._v(" "), _vm.data.length <= 0 ? _c('div', { class: _vm.$style.notFound }, [_vm.emptyImage ? _c('img', { attrs: { "src": _vm.emptyImage, "alt": "not found" } }) : _vm._e(), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.emptyText || _vm.locale.emptyText))])]) : _vm._e()], 2), _vm._v(" "), _vm.data.length > 0 ? _c('div', { class: _vm.$style.clear, on: { "click": function ($event) {
                    _vm.onClear(_vm.title);
                } } }, [_vm._v(" " + _vm._s(_vm.locale.clear) + _vm._s(_vm.title) + " ")]) : _vm._e()]);
    }, staticRenderFns: [], cssModules: { "list": "NoticeTabPane_list_3Q0xK", "item": "NoticeTabPane_item_CEX_k", "meta": "NoticeTabPane_meta_QrhAj", "avatar": "NoticeTabPane_avatar_MHh4U", "read": "NoticeTabPane_read_2gSmJ", "title": "NoticeTabPane_title_BYWTN", "description": "NoticeTabPane_description_18tTR", "datetime": "NoticeTabPane_datetime_1v6sz", "extra": "NoticeTabPane_extra_2K0ST", "notFound": "NoticeTabPane_notFound_DG9lA", "clear": "NoticeTabPane_clear_1LGn2" },
    name: 'TabPane',
    components: { Item: Item },
    props: {
        data: {
            type: Array,
            default: function () { return []; }
        },
        title: {
            type: String,
            default: ''
        },
        emptyImage: {
            type: String
        },
        emptyText: {
            type: String
        }
    },
    data: function data() {
        return {
            prefixCls: prefixCls,
            show: true,
            currentName: this.name
        };
    },
    methods: {
        updateNav: function updateNav() {
            this.$parent.updateNav();
        },
        updateDataFromParent: function updateDataFromParent() {
            this.onClear = this.$parent.$parent.$parent.onClear;
            this.onItemClick = this.$parent.$parent.$parent.onItemClick;
            this.locale = this.$parent.$parent.$parent.locale;
            this.label = this.title;
            if (this.data.length > 0) {
                this.label = (this.label) + " (" + (this.data.length) + ")";
            }
        }
    },
    watch: {
        title: function title() {
            this.updateDataFromParent();
            this.updateNav();
        },
        data: function data() {
            this.updateDataFromParent();
            this.updateNav();
        }
    },
    computed: {
        $style: function $style() {
            return this.$options.cssModules;
        }
    },
    created: function created() {
        this.updateDataFromParent();
    },
    mounted: function mounted() {
        this.updateNav();
    },
    destroyed: function destroyed() {
        this.updateNav();
    }
};

// import Component from 'vue-class-component';
var index = { render: function () {
        var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('Poptip', { staticClass: "turbos-notice-icon", attrs: { "placement": _vm.placement }, on: { "on-popper-show": function ($event) {
                    _vm.onPopupVisibleChange(true);
                }, "on-popper-hide": function ($event) {
                    _vm.onPopupVisibleChange(false);
                } } }, [_c('span', [_c('Badge', { attrs: { "count": _vm.unRead } }, [_vm._t("icon")], 2)], 1), _vm._v(" "), _c('div', { class: _vm.$style.popover, attrs: { "slot": "content" }, slot: "content" }, [_c('Tabs', { attrs: { "animated": false }, on: { "on-click": _vm.onTabChange } }, [_vm._t("default")], 2), _vm._v(" "), _vm.loading ? _c('Spin', { attrs: { "size": "large", "fix": "" } }) : _vm._e()], 1)]);
    }, staticRenderFns: [], cssModules: { "popover": "index_popover_1vCXD" },
    name: 'NoticeIcon',
    Tab: TabPane,
    data: function data() {
        return {
            defaultLocale: {
                emptyText: '暂无数据',
                clear: '清空'
            }
        };
    },
    props: {
        onItemClick: {
            type: Function,
            default: function () {}
        },
        onClear: {
            type: Function,
            default: function () {}
        },
        emptyImage: {
            type: String,
            default: 'https://gw.alipayobjects.com/zos/rmsportal/wAhyIChODzsoKIOBHcBk.svg'
        },
        locale: {
            type: Object,
            default: function () { return ({}); }
        },
        placement: {
            type: String,
            default: 'bottom-start'
        },
        loading: {
            type: Boolean,
            default: false
        },
        onPopupVisibleChange: {
            type: Function,
            default: function () {}
        },
        onTabChange: {
            type: Function,
            default: function () {}
        },
        unRead: {
            type: Number,
            default: 0
        }
    },
    created: function created() {
        this.locale = Object.assign(this.locale, this.defaultLocale);
    },
    computed: {
        $style: function $style() {
            return this.$options.cssModules;
        }
    }
};

module.exports = index;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@hfe/turbos/lib/notice-icon/index.js
// module id = 908
// module chunks = 1